export default __webpack_public_path__ + "static/media/avatar_62.b8d13359.png";